import { ChainId } from 'vvs-sdk'
import { serializeTokens } from './tokens'
import { SerializedPoolConfig, PoolCategory } from './types'

const serializedTokens = serializeTokens()

const mainnetPools: SerializedPoolConfig[] = [
  {
    sousId: 0,
    stakingToken: serializedTokens.vvs,
    earningToken: serializedTokens.vvs,
    contractAddress: {
      25: process.env.REACT_APP_CRAFTSMAN_ADDRESS_MAINNET,
      338: process.env.REACT_APP_CRAFTSMAN_ADDRESS_TESTNET,
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: process.env.REACT_APP_TOKEN_PER_BLOCK,
    sortOrder: 1,
    isFinished: false,
  },
  {
    sousId: 4,
    stakingToken: serializedTokens.vvs,
    earningToken: serializedTokens.single,
    contractAddress: {
      25: '0xe94D70F670d82b250f477D461059201570531CE3',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '4.62962962962962963',
    sortOrder: 1,
    isFinished: false,
  },
  {
    sousId: 3,
    stakingToken: serializedTokens.vvs,
    earningToken: serializedTokens.tonic,
    contractAddress: {
      25: '0xA46c0382654248509A1Ed888ccCBa964693DedcB',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '3472222.222222222222222222',
    sortOrder: 1,
    isFinished: false,
  },
  {
    sousId: 1,
    stakingToken: serializedTokens.vvs,
    earningToken: serializedTokens.bifi,
    contractAddress: {
      25: '0xF0b9B4FbD1d6b6b9B9fa13736Fe12bd2414bc677',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '0.00007777777778',
    sortOrder: 1,
    isFinished: true,
  },
  {
    sousId: 2,
    stakingToken: serializedTokens.vvs,
    earningToken: serializedTokens.bifi,
    contractAddress: {
      25: '0x1a888D7b2abFD2B5046D8461e6D1703F654a8fc0',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '0.00007777777778',
    sortOrder: 1,
    isFinished: false,
  },
]

const testnetPools: SerializedPoolConfig[] = [
  {
    sousId: 0,
    stakingToken: serializedTokens.vvs,
    earningToken: serializedTokens.vvs,
    contractAddress: {
      25: process.env.REACT_APP_CRAFTSMAN_ADDRESS_MAINNET,
      338: process.env.REACT_APP_CRAFTSMAN_ADDRESS_TESTNET,
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: process.env.REACT_APP_TOKEN_PER_BLOCK,
    sortOrder: 1,
    isFinished: false,
  },
  // {
  //   sousId: 1,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.coffee,
  //   contractAddress: {
  //     338: '0x39550a42f29b618a2BcFC4e090a132c33Fa72C99',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '1',
  //   isFinished: true,
  // },
  // {
  //   sousId: 2,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.fish_ball,
  //   contractAddress: {
  //     338: '0x1335169703e3A6C14f5B259a978365355D409e6C',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '2',
  //   isFinished: true,
  // },
  // {
  //   sousId: 3,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.rich_man,
  //   contractAddress: {
  //     338: '0xEe2816c84ca7f56407152Bed442D9b1466dcdbeE',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '200',
  //   isFinished: true,
  // },
  // {
  //   sousId: 4,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.poor_man,
  //   contractAddress: {
  //     338: '0x332146Cd632b1b2da5615bF445fe6A1fc1fB9eeA',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '10',
  //   isFinished: true,
  // },
  // {
  //   sousId: 5,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.banana,
  //   contractAddress: {
  //     338: '0x56B351C62bAC0FFdAaDBf92a700742F3554a4A46',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '1000',
  //   isFinished: true,
  // },
  // {
  //   sousId: 6,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.orange,
  //   contractAddress: {
  //     338: '0x47471C18D96A4eEd3004571Ffe246D4e02352E5d',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '1000',
  //   isFinished: true,
  // },
  // {
  //   sousId: 7,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.salad,
  //   contractAddress: {
  //     338: '0xaa2ada29f78E24870468043Aa813FdCCF91d45C3',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '1000',
  //   isFinished: true,
  // },
  // {
  //   sousId: 8,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.pizza,
  //   contractAddress: {
  //     338: '0x97Bb482b7321dA760C10A459605AB829505C5314',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '1000',
  //   isFinished: true,
  // },
  // {
  //   sousId: 9,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.pizza,
  //   contractAddress: {
  //     338: '0xB1B7c908617ee3567A3c58710f25E4b3F4AFBA50',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '0.00007564755064',
  //   isFinished: true,
  // },
  // {
  //   sousId: 10,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.pizza,
  //   contractAddress: {
  //     338: '0x79FDD3B7251eAbB82492eBcfd118B57697b634E0',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '0.00007564755064',
  //   isFinished: false,
  // },
  // {
  //   sousId: 11,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.pizza,
  //   contractAddress: {
  //     338: '0xc970287636bDBf522B110a635F9259cDa83722FE',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '0.00007777777778',
  //   isFinished: false,
  // },
  // {
  //   sousId: 12,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.ginger,
  //   contractAddress: {
  //     338: '0x8084c709d16C7191f16835BCA3f254Be456029cB',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '3472222.222222222222222222',
  //   isFinished: false,
  // },
  // {
  //   sousId: 13,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.pizza,
  //   contractAddress: {
  //     338: '0x6B86012cBDCD0Abf4Bd5d794891A1fd9f4Dd2F27',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '0.00007777777778',
  //   isFinished: true,
  // },
  // {
  //   sousId: 14,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.muffin,
  //   contractAddress: {
  //     338: '0x09c39E75AF6E80D073142F93EE14C6fC6fcF2A99',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '1543209.876543209876543209',
  //   isFinished: false,
  // },
  {
    sousId: 15,
    stakingToken: serializedTokens.vvs,
    earningToken: serializedTokens.pizza,
    contractAddress: {
      338: '0x6a831bE9D73DEaF7201Da27a623e11357bd9F78a',
      25: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    sortOrder: 999,
    tokenPerBlock: '4.62962962962962963',
    isFinished: false,
  },
]

const pools: SerializedPoolConfig[] =
  process.env.REACT_APP_CHAIN_ID === ChainId.MAINNET.toString() ? mainnetPools : testnetPools

export default pools
